<template>
  <div class="text-center">
      
      <v-card>
        <v-card-title class="text-h5 indigo white--text">
          Ingrese Rango de Fechas
        </v-card-title>

        <v-card-text>
         <v-row>
             <v-col cols="6">
                 <v-text-field
                 type="date"
                v-model="fechas.fechainicio"
                label="Fecha Inicio"
                @change="validarFechas(fechas)"
              ></v-text-field>
             </v-col>
             <v-col cols="6">
                 <v-text-field
                 type="date"
                v-model="fechas.fechafin"
                label="Fecha Fin"
                @change="validarFechas(fechas)"
              ></v-text-field>
             </v-col>
         </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="indigo"
            @click="$emit('ventasporfecha',fechas)" 
            dark
          >
            Filtrar
          </v-btn>
        </v-card-actions>
      </v-card>

  </div>
</template>
<script>
//import Swal from 'sweetalert2';
import dayjs from 'dayjs';

export default {
  props: ["fechas"],
  data:()=>({
    formvalid:false,
  }),
  methods:{
    validarFechas(fechas) {
        fechas.fechainicio = dayjs(fechas.fechainicio).format('YYYY-MM-DD') //.startOf('day')
        fechas.fechafin = dayjs(fechas.fechafin).format('YYYY-MM-DD') //.startOf('day')

        if (fechas.fechainicio > fechas.fechafin) {

          fechas.fechafin = dayjs(fechas.fechainicio).format('YYYY-MM-DD')
          this.formvalid = true

        }
      },
  }
}
</script>